import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserIdenticon from "./UserIdenticon";
import { useMoralis } from 'react-moralis';
import coverImagePlaceHolder from '../../assets/cover-image-placeholder.jpeg'
import { useWeb3React } from '@web3-react/core';
import { getSliceLongTxt, getEllipsisTxt } from '../../helpers/formatters'
import { Link } from "@reach/router";

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

export default function OneCollectionContainer(props) {
  const { data } = props;
  const [nftAttributes, setNftAttributes] = useState(null)
  const { Moralis, isInitialized } = useMoralis()
  const [isLoadingProfile, setIsLoadingProfile] = useState(false)
  const [profileData, setProfileData] = useState({})
  const { account } = useWeb3React()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    try {
      if (isInitialized && nftAttributes) {
        setIsLoadingProfile(true)
        const params = { walletAddress: nftAttributes?.createdBy || null };
        const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
        setProfileData(profileDataResponse)
        setIsLoadingProfile(false)
      }
    } catch (error) {
      setIsLoadingProfile(false)
      setProfileData({})
      console.error("MORALIS : error while fetching profile data ", error)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, nftAttributes])

  useEffect(() => {
    if (data) {
      setNftAttributes(data ? data.attributes : null)
    }
  }, [data])

  const getCoverImage = (moralisAttributes, imageSize = 50) => {
    if (moralisAttributes) {
      if ("coverImageCID" in moralisAttributes && moralisAttributes.coverImageCID != null) {
        const collectionCoverImage = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.coverImageCID}`
        return <img className="collection-cover-image-container" src={collectionCoverImage} alt="" />
      } else {
        return <img className="collection-cover-image-container" src={coverImagePlaceHolder} alt="" />
      }
    } else {
      return <img className="collection-cover-image-container" src={coverImagePlaceHolder} alt="" />
    }
  };

  const getUserImage = (moralisAttributes, imageSize = 50) => {
    if (moralisAttributes) {
      if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
        const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
        return <img className="profile-image-collection" src={profileImageUrl} alt="" />
      } else {
        return (
          <UserIdenticon
            size={imageSize}
            walletAddress={moralisAttributes.walletAddress}
            customCss={{ width: "50px", height: "50px" }}
          />
        );
      }
    } else {
      return (
        <UserIdenticon
          size={imageSize}
          walletAddress={account}
          customCss={{ width: "50px", height: "50px" }}
        />
      );
    }
  };

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 40)
      } else {
        return getEllipsisTxt(data ? data.seller : '', 7)
      }
    } else {
      return getEllipsisTxt(data ? data.seller : '', 7)
    }
  }

  return (
    <div className="collection__item">
      <div className="nft-clickable-container">
      </div>
      <section id='profile_banner_collection_list' className='jumbotron breadcumb-collection no-bg'>
        <Link to={`/collections/${account}/collection/${data.id}`}>
          <Outer>
            <span onClick={() => console.log("sell your nft")}>
              {getCoverImage(nftAttributes, 150)}
              <section className='container d_coll no-top no-bottom'>
                <div className='row'>
                  <div className="col-md-12">
                    <div className="d_profile_collection">
                      <div className="profile_avatar_collection">
                        <div className="d_profile_img nft-cover-image">
                          {getUserImage(profileData?.attributes, 70)}
                        </div>

                        <div className="profile_name">
                          <h4>
                            {nftAttributes ? nftAttributes.name : ''}
                            <div className="clearfix"></div>
                            {
                              isLoadingProfile ?
                                (<div className="spinner-grow spinner-grow-sm" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>)
                                :
                                (<span id="wallet" className="profile_wallet">
                                  {getUsername(profileData ? profileData.attributes : null)}
                                </span>)
                            }
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </span>
          </Outer>
        </Link>
      </section>
    </div>
  );
}
